export default {
  "fr": {
    "employee": {
      "actions": {
        "cancel": "Annuler",
        "changeProfilePicture": "Changer l'Image du Profil",
        "change_role": "Changer de rôle pour",
        "new": "Nouveau Collègue",
        "profilePictureFormat": "Doit être image carrée, au moins 300x300px",
        "save": "Enregistrer",
        "searchEmployee": "Rechercher Collègue",
        "sendinvitation": "Créer et envoyer une invitation",
        "submit": "Enregistrer",
        "undoChanges": "Annuler"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Une fois par jour (vers midi)",
          "hourly": "Toutes les heures",
          "twice_daily": "Deux fois par jour (matin/midi)",
          "weekly": "Une fois par semaine (lundi midi)"
        },
        "first_name": "Prénom",
        "language": "Langue",
        "last_name": "Nom",
        "phone_landline": "Numéro fixe",
        "phone_mobile": "Numéro de portable",
        "profession": "Fonction de Travail",
        "role": "Droits d'accès",
        "signature_html": "Signature des conversations",
        "status": "Status",
        "title": "Titre"
      },
      "labels": {
        "all_projects": "Tous les projets",
        "confirmPasswordReset": "Un email est envoyé avec un lien pour réinitialiser votre mot de passe, veuillez vérifier votre boîte mail, contactez-nous si vous rencontrez des problèmes.",
        "disabled": {
          "access": "Nous accorderons à tous les employés l'accès à la plateforme à partir du moment où la dernière facture impayée est payée.",
          "contact": "Nous contacter",
          "overdue": "Nous avons remarqué que votre dernière facture est en retard depuis longtemps. Nous avons révoqué l'accès de tous les employés sur cette plateforme. Les partenaires et les clients pourront toujours accéder à leurs données.",
          "title": "Votre compte a été désactivé!"
        },
        "generalNotifications": "Informez-moi des",
        "has_access_to": "A accès à",
        "information": "Informations sur le Profil",
        "informationNotificationsEmail": "Recevez une vue d'ensemble par courrier électronique, comprenant uniquement les notifications que vous n'avez pas encore vues sur la plate-forme.",
        "informationNotificationsPlatform": "Recevez toutes les notifications dans votre aperçu personnel situé en haut à droite de votre écran",
        "informationNotificationsTitle": "Décidez quelles notifications vous souhaitez recevoir et par quel canal",
        "its_you!": "C'est vous!",
        "last_login": "Dernière connexion",
        "maintainerAccess": "Nécessite un accès par projet.",
        "name": "Nom",
        "onPlatform": "Sur Plateforme",
        "ownerAccess": "A accès à tous les projets et contenus sur la plate-forme {client_name}.",
        "password": "Mot de passe",
        "permissions": "Droits d'accès pour",
        "permissionsOwnerOnly": "En tant que Projet Mainteneur, vous ne pouvez pas effectuer cette action. Veuillez demander à un collègue de {client_name} ayant le rôle de Propriétaire de le faire pour vous",
        "projectMaintains": "{first_name} a accès aux projets suivants:",
        "projectMaintainsAdd": "Pour accorder l'accès, sélectionnez un projet et ajouter {first_name} en tant que responsable de projet sous la fonctionnalité Informations.",
        "projectMaintainsNone": "n'a accès à aucun projet.",
        "projectNotifications": "Pour le projet",
        "show_signature": "Afficher la signature",
        "signature_active": "Signature active",
        "signature_info": "Cette signature sera ajoutée aux réponses envoyées aux clients et partenaires.",
        "viaEmail": "Par Email"
      },
      "roles": {
        "maintainer": "Mainteneur",
        "owner": "Propriétaire"
      },
      "toasts": {
        "create": "Collègue créé",
        "update": "Collègue modifié"
      },
      "validation": {
        "emailTaken": "L'adresse email a déjà été utilisée",
        "mustBeEmailAddress": "Adresse email valide requis",
        "needFirstName": "Prénom requis",
        "needLastName": "Nom requis",
        "requireEmailAddress": "Email requis"
      }
    }
  }
}